import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import {v4 as uuidv4} from "uuid";

export default {
    mixins: [mainRegistrationMixin],
    computed: {
        participatingPersons: {
            get: function () {
                return this.registrationData.participatingPersons
            },
            set: function (value) {
                this.setRegistrationProp('participatingPersons', value)
            }
        },
        remainingPlacesLeft() {
            const remainingPlaces = this.$store.getters['registration/getNumberOfRemainingPlacesWithCurrentRegistrations']
            return remainingPlaces === null || remainingPlaces > 0 || this.selectMode
        }
    },
    methods: {
        addParticipant(participatingPersonKey = null) {
            if (!this.remainingPlacesLeft) {
                return;
            }
            let participatingPersons = this.$cloneDeep(this.participatingPersons)
            participatingPersonKey = participatingPersonKey ? participatingPersonKey : uuidv4()
            participatingPersons.push(participatingPersonKey)
            this.participatingPersons = participatingPersons

            //Create new Person if not exist
            if (!this.registrationData.persons[participatingPersonKey]) {
                let person = {}
                if (this.$store.state.registration.caregiver) {
                    this.$set(person, 'caregiverUuid', this.$store.state.registration.caregiver.uuid)
                }
                this.$store.commit('registration/setRegistrationPerson', {person: person, key: participatingPersonKey})
            }
        }
    }
}
